import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectModeSingleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V21C2.25 21.4142 2.58579 21.75 3 21.75H21C21.4142 21.75 21.75 21.4142 21.75 21V3C21.75 2.58579 21.4142 2.25 21 2.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectModeSingleIcon.displayName = 'SelectModeSingleIcon';
